<div class="message-container">
    <div class="message">
        <div class="response">
            <h3>A jelszava megváltoztatásához szükséges linket elküldtük az Ön által megadott e-mail címre.</h3>
        </div>
    </div>
</div>
